<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <MovePackingConditionsFormPart @change="onChange" @result="onResult" />

      <h2 class="form-modal__part-title">
        Montage- en demontage werkzaamheden
      </h2>

      <MoveDeAssemblyWorkFormPart @change="onChange" @result="onResult" />

      <h2 class="form-modal__part-title">Voorkeursdatum</h2>

      <MovePreferredDateRadioFormPart @change="onChange" @result="onResult" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import MovePackingConditionsFormPart from 'chimera/moving/components/form/parts/movePackingConditions/MovePackingConditionsFormPart'
import MoveDeAssemblyWorkFormPart from 'chimera/moving/components/form/parts/moveDeAssemblyWork/MoveDeAssemblyWorkFormPart'
import MovePreferredDateRadioFormPart from 'chimera/moving/components/form/parts/movePreferredDate/MovePreferredDateRadioFormPart'
import NextStep from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'PackingConditionsAssemblyDateFormStep',

  components: {
    MovePreferredDateRadioFormPart,
    MovePackingConditionsFormPart,
    MoveDeAssemblyWorkFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * @returns {{willTransitionOnValid: boolean}}
   */
  data() {
    return {
      willTransitionOnValid: true,
    }
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
